import { render, staticRenderFns } from "./FcStack.vue?vue&type=template&id=866ac602&scoped=true&"
import script from "./FcStack.vue?vue&type=script&lang=js&"
export * from "./FcStack.vue?vue&type=script&lang=js&"
import style0 from "./FcStack.vue?vue&type=style&index=0&id=866ac602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866ac602",
  null
  
)

export default component.exports